export const useIsProdEnvCheck = () => {
  // @ts-ignore
  const appConfig = typeof window === 'undefined' ? {} : window.__app_config;

  const getIsProdEnv = () => appConfig.WEBUI_ENV_NAME === 'prod';

  return {
    getIsProdEnv,
  };
};
